import { render } from "./ProductHero.vue?vue&type=template&id=54823eba&scoped=true"
import script from "./ProductHero.vue?vue&type=script&lang=js"
export * from "./ProductHero.vue?vue&type=script&lang=js"

import "./ProductHero.vue?vue&type=style&index=0&id=54823eba&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54823eba"]])

export default __exports__